import { CoreModel } from '../core/core.model';
import { IconModel } from '../icon/icon.model';
import { MenuItemModel } from './menu-item.model';
export class MenuModel extends CoreModel {
/**
 * <p>Icon for menu trigger</p>
 */
triggerIcon?: IconModel;
/**
 * <p>Items source type</p>
 */
itemsSource?: string;
/**
 * <p>Array of menu items</p>
 */
menuItems?: Object[];
/**
 * @hidden
 * @param {?=} values
 */
constructor(values: Object = {}) {
    super(values);
    Object.assign(this, values);
  }
}

function MenuModel_tsickle_Closure_declarations() {
/**
 * <p>Icon for menu trigger</p>
 * @type {?}
 */
MenuModel.prototype.triggerIcon;
/**
 * <p>Items source type</p>
 * @type {?}
 */
MenuModel.prototype.itemsSource;
/**
 * <p>Array of menu items</p>
 * @type {?}
 */
MenuModel.prototype.menuItems;
}

